import { render, staticRenderFns } from "./LoadingSkeletonBase.vue?vue&type=template&id=8e3fe934&"
import script from "./LoadingSkeletonBase.vue?vue&type=script&lang=js&"
export * from "./LoadingSkeletonBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports